<script setup lang="ts">
import { computed } from 'vue';
import { booleanDisplayStringOrNull, BOOLEAN_YES_LABEL } from '@/utils/booleanDisplay';

/**
 * A yes-or-no field: the word "Yes" in the normal text colour, or "No" in
 * muted grey. No check mark, no checkbox and no green. Joel picked the plain
 * word on 2026-10-16 and dropped the green on 2026-10-17.
 */
const props = defineProps<{ value: unknown }>();

const word = computed(() => booleanDisplayStringOrNull(props.value) ?? String(props.value));
const isYes = computed(() => word.value === BOOLEAN_YES_LABEL);
</script>

<template>
  <span
    data-testid="yes-no-value"
    :class="isYes ? 'text-foreground' : 'text-muted-foreground'"
  >{{ word }}</span>
</template>
